import { useState } from "react";

const ResultLoader: React.FC = () => {

    const [text, setText] = useState<boolean>(false);
    setTimeout(() => {
        setText(true);
    }, 2500);

    return (
        <div className="bookshelf_wrapper">
            <ul className="books_list">
                <li className="book_item first"></li>
                <li className="book_item second"></li>
                <li className="book_item third"></li>
                <li className="book_item fourth"></li>
                <li className="book_item fifth"></li>
                <li className="book_item sixth"></li>
            </ul>
            <div className="shelf"></div>
            <p className="translate-y-20 text-3xl text-white text-center">
                {
                    text ?
                        "Curating solutions tailored to your goals.."
                        :
                        "Processing your responses..."
                }
            </p>
        </div>
    )
}

export default ResultLoader;
